module.exports = __webpack_public_path__ + "media/images/icons/event-53b9c64ef085d5fc0fe8f7d4e1c1389d.svg";